<!-- version 2021/05/20 -->
<template>
    <div class="btn-group">
        <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ title }}</button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a href="#" class="dropdown-item">ボタン１</a>
            <a href="#" class="dropdown-item">ボタン２</a>
            <a href="#" class="dropdown-item">ボタン３</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style lang="sass" scoped>
    @mixin arrow-right-position($color:rgba(0, 0, 0, 0.24), $rotate:45deg, $margin-top:0, $right:18px)
        position: relative
        display: inline-block
        &::after
            content: ''
            width: 10px
            height: 10px
            border: 0px
            border-top: solid 2px $color
            border-right: solid 2px $color
            -ms-transform: rotate($rotate)
            -webkit-transform: rotate($rotate)
            transform: rotate($rotate)
            position: absolute
            top: 50%
            right: $right
            margin-top: $margin-top

    button
        @include arrow-right-position(rgba(0, 0, 0, 0.24), 135deg, -8px)
        padding-right: 48px
        text-align: left
        font-size: 16px
        color: #002832
        background-color: #FFF
        border-color: rgba(0, 0, 0, 0.06)
</style>